export const getPartnerType = (partnerInfo) =>
  String(
    partnerInfo?.partnerType ??
      partnerInfo?.partner_type ??
      partnerInfo?.partner?.partnerType ??
      partnerInfo?.partner?.partner_type ??
      "",
  )
    .trim()
    .toLowerCase();

export const canViewPartnerRecharges = (partnerInfo) =>
  ["silver", "gold"].includes(getPartnerType(partnerInfo));
